/**
 * Persian labels for the feedback service's enums.
 *
 * In `lib/` rather than in a screen because the list, the detail, the profile
 * panel and the reports all render the same four vocabularies — and four
 * copies is four chances for «در حال بررسی» to be worded two ways
 * (CLAUDE.md §12).
 */
import { S } from './strings.js';

export const ISSUE_KIND_LABELS = {
  PROBLEM: S.issues.kindProblem,
  CRITICISM: S.issues.kindCriticism,
  SUGGESTION: S.issues.kindSuggestion,
  REQUEST: S.issues.kindRequest,
};

export const ISSUE_PRIORITY_LABELS = {
  LOW: S.issues.priorityLow,
  MEDIUM: S.issues.priorityMedium,
  HIGH: S.issues.priorityHigh,
  URGENT: S.issues.priorityUrgent,
};

export const ISSUE_STATUS_LABELS = {
  OPEN: S.issues.statusOpen,
  IN_PROGRESS: S.issues.statusInProgress,
  WAITING_ON_CONTACT: S.issues.statusWaiting,
  RESOLVED: S.issues.statusResolved,
  CLOSED: S.issues.statusClosed,
};

/** Which colour token a priority reads in. URGENT is the only alarming one. */
export const PRIORITY_CLASS = {
  LOW: 'text-text-muted',
  MEDIUM: 'text-text',
  HIGH: 'text-warning',
  URGENT: 'text-danger',
};

export const STATUS_CLASS = {
  OPEN: 'text-info',
  IN_PROGRESS: 'text-primary',
  WAITING_ON_CONTACT: 'text-warning',
  RESOLVED: 'text-success',
  CLOSED: 'text-text-muted',
};

/**
 * What a status may become, mirroring the feedback service's TRANSITIONS.
 *
 * A CLIENT-SIDE COPY, and it is a convenience rather than the rule: the server
 * refuses anything not in its own table, and reopening a CLOSED issue is
 * ADMIN-only there. What this buys is a picker that offers three plausible
 * moves rather than five, one of which would be refused.
 */
export const NEXT_STATUSES = {
  OPEN: ['IN_PROGRESS', 'CLOSED'],
  IN_PROGRESS: ['WAITING_ON_CONTACT', 'RESOLVED', 'OPEN'],
  WAITING_ON_CONTACT: ['IN_PROGRESS', 'CLOSED'],
  RESOLVED: ['CLOSED', 'IN_PROGRESS'],
  CLOSED: ['IN_PROGRESS'],
};
